import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomerDetailsState } from '../states/customer-details.state';
/** CustomerDetailState */
export const CustomerDetailState = createFeatureSelector<CustomerDetailsState>('customerDetailsState');
/** getCurrentPersona */
export const getCurrentPersona = createSelector(
    CustomerDetailState, (state: CustomerDetailsState) => state && state.customerDetails.persona );
/** getCurrentflowPersona */
export const getCustomerDetails = createSelector(
    CustomerDetailState, (state: CustomerDetailsState) => state);
/** getSelectedReasson for Revokation or Termination */
export const getSelectedcancellationReason = createSelector(
    CustomerDetailState, (state: CustomerDetailsState) => state && state.cancellationReason);
/** getCurrentProcessType */
export const getProcessType = createSelector(
    CustomerDetailState, (state: CustomerDetailsState) => state && state.customerDetails.processType);
/** getCurrentCustomerType */
export const getCustomerType = createSelector(
    CustomerDetailState, (state: CustomerDetailsState) => state && state.customerDetails.customerType);
/** getCurrentCustomerType */
export const getxConversationId = createSelector(
    CustomerDetailState, (state: CustomerDetailsState) => state && state.xConversationId);
    /** getDownloadStatus wither qr-code or label only */
export const getDownloadStatus = createSelector(
    CustomerDetailState, (state: CustomerDetailsState) => state && state.downloadedStatus);
/** getAccountAgentStatus in Termination to determine if redirection to chat component from sales agent page or assisted agent page*/
export const getAccountAgentStatus = createSelector(
    CustomerDetailState, (state: CustomerDetailsState) => state && state.isAccountAgent);
